<template>
  <PageSecondary>
    <template #title>Level Up На Профе</template>
    <h1>Тони и Групповая Динамика</h1>
    <h5>
      <span>Вечер четверга 17 сентября, 19:00-22:00</span>
      <br>
      <a href="https://yandex.ru/maps/geo/metro_profsoyuznaya/100078796" target="_blank">м. Профсоюзная</a>
      <!--      <span style="margin: auto 8px;">&#45;&#45;</span>-->
      <br>
      <span>Бесплатно</span>
    </h5>
    <div v-if="secret==='fhs2o0ly3'">
      Улица Профсоюзная 17к3, подъезд 2<br>
      Код домофона 28к2430<br>
      Этаж 5, Квартира 28, Дверь открыта
    </div>
    <img src="@/assets/gd3.jpg" style="max-width: 100%; padding: 16px 64px 0; box-sizing: border-box;">
    <ul style="">
      <li>Приятные люди в поиске развития</li>
      <li>Документальное кино о Тони Робинсе</li>
      <li>Тренинг "Групповая динамика" от <a href="https://instagram.com/irinabond.bond" target="_blank">Ирины</a></li>
      <li>Горячий чай, пледы, свечи, плюшки</li>
    </ul>
    <img src="@/assets/gd1.gif" style="max-width: 100%;">
    Всего 8 участников, осталось 1 место. Напиши мне, чтобы участвовать и узнать адрес.
  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";

export default {
  name: 'LevelUpAtProfa_2020_09_17',
  components: {PageSecondary},
  props: {
    secret: String,
  }
}
</script>
